import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, CardContent } from '@mui/material';
import { useParams, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';

import { ViewTitle } from '@iarcpsu/emanufac-components/src/components/ViewTitle';
import * as actions from '../../redux/actions';
import { ResultingFunctionTypeForm } from '@iarcpsu/emanufac-components/src/components/Forms';
import Loading from '@iarcpsu/emanufac-components/src/components/Loading';
import { Error } from '@iarcpsu/emanufac-components/src/components/Error';
import { BackButton } from '@iarcpsu/emanufac-components/src/components/Button';
import { app as appConfig } from '../../configs';
import api from '../../configs/api';

export default function EditResultingFunctionType({ title, subtitle }) {
  const dispatch = useDispatch();
  const resultingFunctionType = useSelector(
    (state) => state.resultingFunctionType,
  );
  const measurementType = useSelector((state) => state.measurementType);
  const organizationConstant = useSelector(
    (state) => state.organizationConstant,
  );

  const params = useParams();
  const history = useHistory();
  const [allResutlingFT, setAllResultingFT] = useState({});

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({ defaultValues: resultingFunctionType });

  const onSubmit = async (data) => {
    try {
      await dispatch(actions.resultingFunctionTypePut(params.id, data));
      alert('แก้ไขฟังก์ชันการแสดงผลสำเร็จ');
      history.goBack();
    } catch (error) {
      window.alert(`แก้ไขฟังก์ชันการแสดงผลไม่สำเร็จ${error?.message}`);
      console.error('Error on Edit Unit', error);
    }
  };

  // TODO: Using Graphql instead
  useEffect(() => {
    dispatch(actions.resultingFunctionTypeGet(params.id));
    dispatch(
      actions.organizationConstantAll({
        name: '',
        size: appConfig.maxFetchSize,
        page: 1,
      }),
    );
    dispatch(
      actions.measurementTypeAll({
        name: '',
        size: appConfig.maxFetchSize,
        page: 1,
      }),
    );
    return () => {};
  }, []);

  useEffect(() => {
    if (resultingFunctionType?.name) {
      setValue('name', resultingFunctionType?.name);
      setValue('executor', resultingFunctionType?.executor);
    }
    return () => {};
  }, [resultingFunctionType]);

  const fetchAnotherRFT = async () => {
    try {
      const { data } = await api.get(
        `${process.env.REACT_APP_API_URL}/resulting-function-type?page=1&size=${appConfig.maxFetchSize}`,
      );
      setAllResultingFT(data);
    } catch (error) {
      console.error('Cannot Fetch All Another Resulting Function Types');
    }
  };

  useEffect(() => {
    fetchAnotherRFT();

    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const renderForm = () => (
    <div className="my-2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Card>
          <CardContent>
            <ResultingFunctionTypeForm
              control={control}
              errors={errors}
              measurementType={measurementType}
              organizationConstant={organizationConstant}
              resultingFunctionType={resultingFunctionType}
              watch={watch}
              setValue={setValue}
              resultingFunctionTypesArray={allResutlingFT}
            />
          </CardContent>
        </Card>
        <div className="flex flex-row justify-end gap-1 py-4">
          <Button variant="contained" type="submit">
            บันทึก
          </Button>
        </div>
      </form>
    </div>
  );
  const renderBackButton = () => (
    <div className="flex justify-start">
      <BackButton />
    </div>
  );
  if (resultingFunctionType.isLoading || resultingFunctionType?.rows) {
    return <Loading />;
  }
  if (!resultingFunctionType.isLoading && resultingFunctionType.isCompleted) {
    return (
      <div>
        {renderTitle()}
        {renderBackButton()}
        {renderForm()}
      </div>
    );
  }
  return <Error />;
}
EditResultingFunctionType.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditResultingFunctionType.defaultProps = {
  title: '',
  subtitle: '',
};
